import React from 'react';
import { motion } from 'framer-motion';
import { Github, Linkedin, Mail, Heart } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-black border-t border-amber-900/20 overflow-hidden">
      {/* Japanese background */}
      <div className="absolute inset-0">
        <div className="absolute bottom-0 right-0 text-[10rem] font-bold text-amber-100/[0.02] select-none">終</div>
      </div>
      
      {/* Decorative top line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-red-700 to-transparent" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12 items-center">
          {/* Logo/Name */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="font-bebas text-3xl tracking-wider text-amber-100">
              <span className="text-red-700">侍</span> ADITYA NARAYAN
            </span>
            <p className="mt-2 text-sm text-amber-100/40">
              Versatile Software Engineer
            </p>
            <p className="mt-1 text-xs text-amber-100/20 tracking-widest">
              武士の魂 • Soul of the Warrior
            </p>
          </motion.div>

          {/* Center Quote */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-center"
          >
            <p className="text-sm text-amber-100/30 italic mb-2">
              "Honor. Discipline. Excellence."
            </p>
            <p className="text-xs text-red-700/50">
              名誉 • 規律 • 卓越
            </p>
          </motion.div>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="flex justify-center md:justify-end gap-4"
          >
            {[
              { icon: Github, href: `https://${personalInfo.github}` },
              { icon: Linkedin, href: `https://${personalInfo.linkedin}` },
              { icon: Mail, href: `mailto:${personalInfo.email}` },
            ].map((item, i) => (
              <motion.a
                key={i}
                href={item.href}
                target={item.icon !== Mail ? "_blank" : undefined}
                rel="noopener noreferrer"
                className="p-3 text-amber-100/40 hover:text-amber-100 border border-amber-900/20 hover:border-red-700/40 rounded-lg transition-all duration-300"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <item.icon size={18} />
              </motion.a>
            ))}
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-amber-900/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-amber-100/30">
            © {currentYear} Aditya Narayan. All rights reserved.
          </p>
          <p className="flex items-center gap-2 text-xs text-amber-100/30">
            Crafted with <Heart size={12} className="text-red-600" /> & the Spirit of the Samurai
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
